import { Announcement } from "./Announcement";
import { Bye } from "./Bye";
import { CommunityVoting } from "./CommunityVoting";
import { Gallery } from "./Gallery";
import { GuestBook } from "./GuestBook";
import { Money } from "./Money";
import { Parent } from "./Parent";
import { WeddingPlace } from "./WeddingPlace";

export function Contents() {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "start",
      }}
    >
      <Parent />
      <Announcement />
      <Gallery />
      <CommunityVoting />
      <GuestBook />
      <WeddingPlace />
      <Money />
      <Bye />
    </div>
  );
}
